import {
  useEffect,
  useState,
} from "react";

import {
  AnimatePresence,
  motion,
  useReducedMotion,
} from "framer-motion";

/*
  ============================================================
  PHOTOGRAPHY PREMIUM
  SCROLL TO TOP
  ============================================================

  - Näkyy vasta kun sivua on vieritetty riittävästi.
  - Toimii Ivory / Noir -teemoilla tokenien kautta.
  - FI / EN saavutettavuusteksti.
  - Reduced motion huomioidaan.
  - Pienellä mobiililla nappi piilotetaan, jotta se ei peitä sisältöä.
*/

export default function ScrollToTopButton({
  language = "fi",
}) {
  const [
    visible,
    setVisible,
  ] = useState(false);

  const reduceMotion =
    useReducedMotion();

  useEffect(() => {
    const handleScroll =
      () => {
        setVisible(
          window.scrollY >
            700
        );
      };

    handleScroll();

    window.addEventListener(
      "scroll",
      handleScroll,
      {
        passive: true,
      }
    );

    return () => {
      window.removeEventListener(
        "scroll",
        handleScroll
      );
    };
  }, []);

  const handleClick =
    () => {
      window.scrollTo({
        top: 0,

        behavior:
          reduceMotion
            ? "auto"
            : "smooth",
      });
    };

  const label =
    language === "en"
      ? "Back to top"
      : "Takaisin ylös";

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          type="button"
          onClick={
            handleClick
          }
          aria-label={
            label
          }
          title={label}
          initial={{
            opacity: 0,
            y: 12,
            scale: 0.94,
          }}
          animate={{
            opacity: 1,
            y: 0,
            scale: 1,
          }}
          exit={{
            opacity: 0,
            y: 10,
            scale: 0.94,
          }}
          transition={{
            duration:
              reduceMotion
                ? 0
                : 0.28,

            ease: [
              0.22,
              1,
              0.36,
              1,
            ],
          }}
          whileHover={
            reduceMotion
              ? undefined
              : {
                  y: -3,
                }
          }
          whileTap={
            reduceMotion
              ? undefined
              : {
                  scale: 0.96,
                }
          }
          className="
            fixed
            bottom-5
            right-5
            z-40
            hidden
            h-12
            w-12
            items-center
            justify-center
            rounded-full
            border
            border-border
            bg-canvas/90
            text-text
            shadow-sm
            backdrop-blur-md
            transition-colors
            duration-300

            hover:border-text

            sm:bottom-7
            sm:right-7
            sm:flex
            sm:h-13
            sm:w-13
          "
        >
          <span
            className="
              relative
              block
              h-5
              w-5
            "
            aria-hidden="true"
          >
            <span
              className="
                absolute
                left-1/2
                top-[3px]
                h-[9px]
                w-[9px]
                -translate-x-1/2
                rotate-45
                border-l
                border-t
                border-current
              "
            />

            <span
              className="
                absolute
                left-1/2
                top-[4px]
                h-[15px]
                w-px
                -translate-x-1/2
                bg-current
              "
            />
          </span>
        </motion.button>
      )}
    </AnimatePresence>
  );
}